__webpack_require__.p = "/akalny/";